document.addEventListener("DOMContentLoaded", function() {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.titleTexts = null;
      this.productItems = null;
      this.tabHandlers = [];
      this.titleTextHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-products-item');
      this.titleTexts = this.querySelectorAll('.yg-collection-products-title-text');
      this.productItems = this.querySelectorAll('.yg-collection-product-item');

      // 初始化一级切换：只在没有任何 active 时才添加
      const hasActiveTab = Array.from(this.tabs).some(tab => tab.classList.contains('active'));
      const hasActiveItem = Array.from(this.items).some(item => item.classList.contains('active'));
      
      if (!hasActiveTab) {
        this.tabs[0]?.classList.add('active');
      }
      if (!hasActiveItem) {
        this.items[0]?.classList.add('active');
      }

      // 初始化二级切换：只在没有任何 active 时才添加
      const hasActiveTitle = Array.from(this.titleTexts).some(title => title.classList.contains('active'));
      const hasActiveProduct = Array.from(this.productItems).some(product => product.classList.contains('active'));
      
      if (!hasActiveTitle) {
        this.titleTexts[0]?.classList.add('active');
      }
      if (!hasActiveProduct) {
        this.productItems[0]?.classList.add('active');
      }

      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    // 一级切换：左侧 tab ↔ 右侧 products-item
    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((item, j) => item.classList.toggle('active', index === j));
    }

    // 二级切换：右侧 title-text ↔ 右侧 product-item（只切换同一 products-item 下的）
    switchSubTab(clickedTitle) {
      // 找到点击元素的父容器 yg-collection-products-item
      const parentItem = clickedTitle.closest('.yg-collection-products-item');
      if (!parentItem) return;

      // 在父容器内找到所有的 title-texts 和 product-items
      const titleTextsInItem = parentItem.querySelectorAll('.yg-collection-products-title-text');
      const productItemsInItem = parentItem.querySelectorAll('.yg-collection-product-item');

      // 找到点击元素在同一父容器内的索引
      const index = Array.from(titleTextsInItem).indexOf(clickedTitle);
      if (index === -1) return;

      // 切换同一父容器下的元素
      titleTextsInItem.forEach((title, j) => {
        title.classList.toggle('active', j === index);
      });
      productItemsInItem.forEach((product, j) => {
        product.classList.toggle('active', j === index);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.titleTextHandlers.forEach(({ title, handler, type }) => {
        title.removeEventListener(type, handler);
      });
      this.tabHandlers = [];
      this.titleTextHandlers = [];

      // 一级切换：左侧 tabs 事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });

      // 二级切换：右侧 title-texts 事件（始终使用点击）
      this.titleTexts.forEach((title, i) => {
        const handler = (e) => this.switchSubTab(e.currentTarget);
        title.addEventListener('click', handler);
        this.titleTextHandlers.push({ title, handler, type: 'click' });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.titleTextHandlers.forEach(({ title, handler, type }) => {
        title.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YgMegaMenuMobile extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.innerWidth < 1150; // 当前状态记录
    }

    connectedCallback() {
      this.init();
      this.bindResizeWatcher();
    }

    init() {
      const menuItems = Array.from(this.querySelectorAll('.yg-mega-menu-item'));
      const productBoxes = Array.from(this.querySelectorAll('.yg-mega-products-box'));
      const productsContainer = this.querySelector('.yg-mega-menu-products');
      const productsHeaderTitles = this.querySelectorAll('.yg-mega-products-header .yg-mega-menu-title');

      if (!menuItems.length || !productBoxes.length) return;

      menuItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          menuItems.forEach(i => i.classList.remove('active'));
          productBoxes.forEach(i => i.classList.remove('active'));

          item.classList.add('active');
          if (productBoxes[index]) productBoxes[index].classList.add('active');

          if (window.innerWidth < 1150 && productsContainer) {
            productsContainer.classList.add('active');
          }
        });
      });

      // 每个 products-box 的 header title 都可以点击返回
      productsHeaderTitles.forEach((title) => {
        title.addEventListener('click', () => {
          if (window.innerWidth < 1150 && productsContainer) {
            productsContainer.classList.remove('active');
          }
        });
      });
    }

    bindResizeWatcher() {
      const productsContainer = this.querySelector('.yg-mega-menu-products');

      window.addEventListener('resize', () => {
        const isNowMobile = window.innerWidth < 1150;

        if (!isNowMobile && this.isMobile && productsContainer) {
          productsContainer.classList.remove('active');
        }

        this.isMobile = isNowMobile;
      });
    }
  }

  if (!customElements.get('yg-mega-menu-mobile')) {
    customElements.define('yg-mega-menu-mobile', YgMegaMenuMobile);
  }

  // YG Quantity Selector - 代理点击到 .product-info__quantity-selector
  class YGQuantitySelector extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.isBound = false;
      this.init();
    }

    init() {
      // 设置 MutationObserver 来监视 DOM 变化
      this.setupObserver();

      // 尝试初始绑定
      this.tryBind();
    }

    setupObserver() {
      this.observer = new MutationObserver((mutations) => {
        let shouldCheckRebind = false;

        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            // 检查是否有 .product-info__quantity-selector 相关的变化
            const checkForQuantitySelector = (nodes) => {
              for (const node of nodes) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.classList && node.classList.contains('product-info__quantity-selector')) {
                    return true;
                  }
                  if (node.querySelector && node.querySelector('.product-info__quantity-selector')) {
                    return true;
                  }
                  // 递归检查子节点
                  if (node.children && checkForQuantitySelector(node.children)) {
                    return true;
                  }
                }
              }
              return false;
            };

            if (checkForQuantitySelector(mutation.addedNodes) || checkForQuantitySelector(mutation.removedNodes)) {
              shouldCheckRebind = true;
              break;
            }
          }
        }

        if (shouldCheckRebind) {
          // 延迟执行以确保 DOM 完全更新
          setTimeout(() => {
            this.tryBind();
          }, 10);
        }
      });

      // 开始观察整个文档的变化
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    tryBind() {
      const originalSelector = document.querySelector('.product-info__quantity-selector');

      if (originalSelector && !this.isBound) {
        // 发现新的 quantity selector，进行绑定
        this.bindToSelector(originalSelector);
      } else if (!originalSelector && this.isBound) {
        // quantity selector 被移除，解绑
        this.unbind();
      } else if (originalSelector && this.isBound) {
        // 检查是否是同一个元素，如果不是则重新绑定
        const currentOriginalInput = originalSelector.querySelector('.quantity-selector__input');
        if (currentOriginalInput !== this.boundOriginalInput) {
          this.unbind();
          this.bindToSelector(originalSelector);
        }
      }
    }

    bindToSelector(originalSelector) {
      // 先解绑之前的绑定
      this.unbind();

      // 获取原始选择器中的所有按钮
      const originalButtons = originalSelector.querySelectorAll('.quantity-selector__button');
      if (originalButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const originalDecreaseBtn = originalButtons[0];
      const originalIncreaseBtn = originalButtons[1];

      // 获取原始选择器中的输入框
      this.boundOriginalInput = originalSelector.querySelector('.quantity-selector__input');

      // 获取当前元素中的所有按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const decreaseBtn = currentButtons[0];
      const increaseBtn = currentButtons[1];

      // 获取当前元素中的输入框
      const currentInput = this.querySelector('.quantity-selector__input');

      // 创建事件处理器
      this.currentDecreaseHandler = (e) => {
        e.preventDefault();
        if (originalDecreaseBtn) {
          originalDecreaseBtn.click();
        }
      };

      this.currentIncreaseHandler = (e) => {
        e.preventDefault();
        if (originalIncreaseBtn) {
          originalIncreaseBtn.click();
        }
      };

      // 为减号按钮添加事件监听器
      if (decreaseBtn && originalDecreaseBtn) {
        decreaseBtn.addEventListener('click', this.currentDecreaseHandler);
      }

      // 为加号按钮添加事件监听器
      if (increaseBtn && originalIncreaseBtn) {
        increaseBtn.addEventListener('click', this.currentIncreaseHandler);
      }

      // 同步一次数字值
      if (currentInput && this.boundOriginalInput) {
        currentInput.value = this.boundOriginalInput.value;
      }

      this.isBound = true;
    }

    unbind() {
      if (!this.isBound) return;

      // 获取当前元素中的按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length >= 2) {
        const decreaseBtn = currentButtons[0];
        const increaseBtn = currentButtons[1];

        // 移除事件监听器
        if (decreaseBtn && this.currentDecreaseHandler) {
          decreaseBtn.removeEventListener('click', this.currentDecreaseHandler);
        }
        if (increaseBtn && this.currentIncreaseHandler) {
          increaseBtn.removeEventListener('click', this.currentIncreaseHandler);
        }
      }

      // 清除引用
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.boundOriginalInput = null;
      this.isBound = false;
    }

    disconnectedCallback() {
      this.unbind();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!window.customElements.get('yg-quantity-selector')) {
    window.customElements.define('yg-quantity-selector', YGQuantitySelector);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGModal extends HTMLElement {
    constructor() {
      super();
      this.modalTriggers = [];
      this.modals = [];
      this.closeButtons = [];
    }

    connectedCallback() {
      this.init();
      this.moveModalsToBody();
    }

    moveModalsToBody() {
      this.modals = this.querySelectorAll('.yg-modal');
      this.modals.forEach((modal) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
      });
    }

    init() {
      this.modalTriggers = this.querySelectorAll('.yg-modal-trigger');
      // document
      this.modals = document.querySelectorAll('.yg-modal');
      this.closeButtons = document.querySelectorAll('.yg-modal-close');
      this.bindEvents();
    }

    bindEvents() {
      // open modal
      this.modalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const modalId = trigger.getAttribute('data-modal');
          const modal = document.getElementById(modalId);
          if (modal) {
            this.openModal(modal);
          }
        });
      });

      // close modal
      this.closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          const modal = closeBtn.closest('.yg-modal');
          this.closeModal(modal);
        });
      });

      // outside click
      this.modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            this.closeModal(modal);
          }
        });
      });
    }

    openModal(modal) {
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    closeModal(modal) {
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = 'auto';
      }
    }
  }

  if (!customElements.get('yg-modal')) {
    customElements.define('yg-modal', YGModal);
  }
});